import { useEffect, useRef } from "react"
import didSaySomething from '../functions/didSaySomething'

export default function useDetectStudentDidSaySomething({volumeStats}) {

    const studentDidSaySomething = useRef(false)

    useEffect(()=>{
        const {maxVolume} = volumeStats
        // force pass the max / min volume delta check if maxVolume is finite
        if(didSaySomething(volumeStats, true) && !studentDidSaySomething.current && Number.isFinite(maxVolume)){
            studentDidSaySomething.current = true;
        }
    }, [volumeStats.instant])

    const resetDidSaySomething = () => {
        studentDidSaySomething.current = false
    }

    return {studentDidSaySomething, resetDidSaySomething}
}